import React from "react";
import { COMP_METRICS } from "./comparatiiMetrics";

export default function ComparatiiOverview({ data, metric }) {
  const countries = data?.countries || [];
  return (
    <div data-testid="comparatii-overview-card" className="mt-4 rounded border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-slate-700">Privire de ansamblu - toate metricile (top tari)</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-slate-100">
              <th className="sticky left-0 bg-slate-100 px-2 py-1.5 text-left font-semibold">Metrica</th>
              <th className="px-2 py-1.5 text-right font-semibold">Total</th>
              {countries.map((c) => <th key={c} className="whitespace-nowrap px-2 py-1.5 text-right font-semibold">{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {COMP_METRICS.map(([k, l]) => {
              const s = data?.series?.[k];
              const hl = k === metric;
              return (
                <tr key={k} className={`border-b border-slate-100 hover:bg-slate-50 ${hl ? "bg-cyan-50" : ""}`}>
                  <td className={`sticky left-0 px-2 py-1 font-semibold ${hl ? "bg-cyan-50" : "bg-white"}`}>{l}</td>
                  <td className="px-2 py-1 text-right font-bold">{s?.total || 0}</td>
                  {countries.map((c) => <td key={c} className="px-2 py-1 text-right">{s?.by_country?.[c] || 0}</td>)}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
